import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
// eslint-disable-next-line no-restricted-imports
import NextLink, { type LinkProps } from 'next/link';
import { usePathname } from 'next/navigation';
import type { AnchorHTMLAttributes, PropsWithChildren } from 'react';
import { docsBaseUrl } from '@/contexts/environment';
import { useViewParameters } from '@/contexts/navigation';
import { serialize } from '@/contexts/navigation/serialization';
export interface GeneralLinkProps extends PropsWithChildren<LinkProps>, Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'href'> {
  disabled?: boolean;
}
export const Link = props => {
  const $ = _c(19);
  let onClick;
  let rest;
  if ($[0] !== props) {
    ({
      onClick,
      ...rest
    } = props);
    $[0] = props;
    $[1] = onClick;
    $[2] = rest;
  } else {
    onClick = $[1];
    rest = $[2];
  }
  let t0;
  if ($[3] !== props.href) {
    t0 = typeof props.href === "string" && props.href.startsWith(docsBaseUrl) ? {
      prefetch: false
    } : {};
    $[3] = props.href;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  const disablePrefetchProps = t0;
  let t1;
  if ($[5] !== onClick || $[6] !== props.disabled) {
    t1 = event => {
      if (props.disabled) {
        event.preventDefault();
        return;
      }
      onClick?.(event);
    };
    $[5] = onClick;
    $[6] = props.disabled;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  const t2 = props.className ? props.className : "";
  let t3;
  if ($[8] !== props.disabled || $[9] !== t2) {
    t3 = classNames(t2, {
      "pointer-events-none": props.disabled
    });
    $[8] = props.disabled;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const t4 = props.disabled ? -1 : undefined;
  let t5;
  if ($[11] !== disablePrefetchProps || $[12] !== props.children || $[13] !== props.disabled || $[14] !== rest || $[15] !== t1 || $[16] !== t3 || $[17] !== t4) {
    t5 = <NextLink {...disablePrefetchProps} {...rest} onClick={t1} className={t3} aria-disabled={props.disabled} tabIndex={t4}>{props.children}</NextLink>;
    $[11] = disablePrefetchProps;
    $[12] = props.children;
    $[13] = props.disabled;
    $[14] = rest;
    $[15] = t1;
    $[16] = t3;
    $[17] = t4;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  return t5;
};
type NavigationLinkProps = Omit<GeneralLinkProps, 'href'> & {
  path: string;
  searchParams?: Record<string, unknown>;
};
export const NavigationLink = props => {
  const $ = _c(14);
  let path;
  let rest;
  let t0;
  if ($[0] !== props) {
    ({
      path,
      searchParams: t0,
      ...rest
    } = props);
    $[0] = props;
    $[1] = path;
    $[2] = rest;
    $[3] = t0;
  } else {
    path = $[1];
    rest = $[2];
    t0 = $[3];
  }
  const searchParams = t0 === undefined ? {} : t0;
  const {
    getAll,
    setParams
  } = useViewParameters();
  const currentPath = usePathname();
  const hasSearchParams = Object.keys(searchParams).length > 0;
  let url = path;
  if (hasSearchParams) {
    const {
      pageIndex,
      ...currentParams
    } = getAll();
    const params = path === currentPath ? {
      ...Object.entries(currentParams).reduce(_temp, {}),
      ...searchParams
    } : searchParams;
    url = url + `?${new URLSearchParams(serialize(params))}`;
  }
  let t1;
  if ($[4] !== currentPath || $[5] !== hasSearchParams || $[6] !== path || $[7] !== searchParams || $[8] !== setParams) {
    t1 = () => {
      if (hasSearchParams && path === currentPath) {
        setParams(state => ({
          ...state,
          ...searchParams
        }));
      }
    };
    $[4] = currentPath;
    $[5] = hasSearchParams;
    $[6] = path;
    $[7] = searchParams;
    $[8] = setParams;
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  let t2;
  if ($[10] !== rest || $[11] !== t1 || $[12] !== url) {
    t2 = <Link {...rest} href={url} onClick={t1} />;
    $[10] = rest;
    $[11] = t1;
    $[12] = url;
    $[13] = t2;
  } else {
    t2 = $[13];
  }
  return t2;
};
function _temp(acc, t0) {
  const [key, value] = t0;
  acc[key] = key === "pageIndex" ? 0 : value;
  return acc;
}